import { render, staticRenderFns } from "./MCQModification.vue?vue&type=template&id=029c5c44&scoped=true&"
import script from "./MCQModification.vue?vue&type=script&lang=js&"
export * from "./MCQModification.vue?vue&type=script&lang=js&"
import style0 from "./MCQModification.vue?vue&type=style&index=0&id=029c5c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029c5c44",
  null
  
)

export default component.exports